"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSyncField = createSyncField;
/**
 * Creates a new SyncField with an initial value
 */
function createSyncField(value) {
    return { value, pending: undefined };
}
